import { lazy } from "react";
import { Route, Switch } from "react-router-dom";

import PdpAttributesFormattingPage from "@faire/prototype-playground/workspace/et/pdp-attributes-formatting";

import { withCompass } from "../../components/compass/withCompass";

const SpeRevampPage = lazy(() => import("../../workspace/et/spe-revamp/Page"));
const LqRetailerPreviewPage = lazy(
  () => import("../../workspace/et/lq-retailer-preview/Page")
);

const RetroactiveInsiderSavingsPage = withCompass(
  () => import("../../pages/RetroactiveInsiderSavingsPage")
);
const SavingsVisibilityPage = withCompass(
  () => import("../../pages/SavingsVisibilityPage")
);

export function EmThompsonRoutes() {
  return (
    <Switch>
      <Route path="/et/lq-retailer-preview" component={LqRetailerPreviewPage} />
      <Route path="/et/pdp-attributes-formatting" component={PdpAttributesFormattingPage} />
      <Route
        path="/et/retroactive-insider-savings"
        component={RetroactiveInsiderSavingsPage}
      />
      <Route path="/et/savings-visibility" component={SavingsVisibilityPage} />
      <Route path="/et/spe-revamp" component={SpeRevampPage} />
    </Switch>
  );
}

export const slug = "et";
